var _circle, _circle2, _circle3, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclesProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 355,
    viewBox: "0 0 340 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 250,
    r: 48.5,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 250.5 276.5)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 278.5 203.5)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 354C200.978 354 280 274.978 280 177.5C280 80.0217 200.978 1 103.5 1C6.02174 1 -73 80.0217 -73 177.5C-73 274.978 6.02174 354 103.5 354ZM103.5 355C201.531 355 281 275.531 281 177.5C281 79.4695 201.531 0 103.5 0C5.46946 0 -74 79.4695 -74 177.5C-74 275.531 5.46946 355 103.5 355Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 38,
    x2: 43,
    y2: 116,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesProduct);
export default __webpack_public_path__ + "static/media/circles_product.9a024fe29eaac374a863d0470a3cca9b.svg";
export { ForwardRef as ReactComponent };